
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './LoginForm.css';
import SignupForm from './SignupForm';
import config from '../config';

const LoginForm = ({ onLoginSuccess, onBack }) => {
  const [showSignup, setShowSignup] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  if (showSignup) {
    return <SignupForm onSwitchToLogin={() => setShowSignup(false)} />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Basic validation
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      setLoading(false);
      return;
    }

    const result = await login(username, password);

    if (result.success) {
      // This line is critical - it must be called
      if (onLoginSuccess) {
        onLoginSuccess();  // Make sure this is being called
      }
    } else {
      setError(result.error || 'Login failed. Please check your credentials.');
    }

    setLoading(false);
  };

  // For demo purposes - quick fill test credentials
  const fillTestCredentials = () => {
    setUsername('testuser');
    setPassword('testpass123');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Back Button - calls onBack when clicked */}
        {onBack && (
          <button onClick={onBack} className="back-to-landing" type="button">
            ← Back to Home
          </button>
        )}
        <div className="login-header">
          <span className="login-icon">📋</span>
          <h2>{config.APP_NAME}</h2>
          <p>Sign in to access your forms</p>
        </div>

        {error && (
          <div className="login-error">
            <span className="error-icon">⚠️</span>
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">
              Username <span className="required-star">*</span>
            </label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={loading}
                placeholder="Enter your username"
                autoComplete="username"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">
              Password <span className="required-star">*</span>
            </label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </div>
          </div>

          <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" /> Remember me
            </label>
            <a href="#" className="forgot-password">Forgot password?</a>
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loading-spinner"></span>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>

        {/* <div className="test-credentials">
          <p className="test-credentials-title">🔑 Test Credentials</p>
          <div className="credential-box" onClick={fillTestCredentials}>
            <span className="credential-user">testuser</span>
            <span className="credential-pass">testpass123</span>
            <span className="credential-hint">(click to fill)</span>
          </div>
        </div> */}

        <div className="login-footer">
          <p>
            Don't have an account?{' '}
            <button
              onClick={() => setShowSignup(true)}
              className="switch-link"
            >
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;

